import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-4 whitespace-nowrap">
            最新动态
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            漫画更新快讯
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">第一时间掌握漫画更新、新作上线和平台活动动态</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300/60"></div>

          <div className="space-y-6 md:space-y-8">
            {updatesData.map((item, i) => (
              <div key={i} className="relative pl-10 md:pl-14">
                <div className="absolute left-2.5 md:left-[21px] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>

                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mb-2">
                  <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">{item.date}</span>
                  <span className={`inline-block px-2 py-0.5 text-[10px] font-medium rounded whitespace-nowrap ${
                    item.tag === '热门' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '推荐' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '新作' ? 'bg-secondary-100 text-secondary-700' :
                    'bg-background-200 text-foreground-600'
                  }`}>
                    {item.tag}
                  </span>
                </div>

                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}